import { cardContainerStyles } from "@insite/content-library/Components/CardContainer";
import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { headerStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsHeader";
import { orderInformationStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation";
import { filterStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListFilter";
import { billingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsBillingAddress";
import { shippingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingAddress";
import { clearButtonStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchClearButton";
import { orderHistorySearchFieldProductErpNumber2Styles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldProductErpNumber2";
import { shipToStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldShipTos";
import { searchFormStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";

import getColor from "@insite/mobius/utilities/getColor";
import { orderLinesListStyles } from "@tCooneyBrothers/Overrides/Components/OrderLinesList";
import { css } from "styled-components";

filterStyles.toDate = {
    cssOverrides: {
        formField: css`
            .react-datetime-picker__calendar.react-datetime-picker__calendar--open {
                left: unset !important;
                // right: 280px !important;
            }
        `,
    },
};
shipToStyles.select = {
    cssOverrides: {
        inputSelect: css`
            padding-right: 30px !important;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            & + span {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        `,
    },
};
orderHistorySearchFieldProductErpNumber2Styles.searchDynamicDropdown = {
    cssOverrides: {
        inputSelect: css`
            padding-right: 30px !important;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            & + span {
                width: 250px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        `,
    },
};
filterStyles.container = {
    css: css`
        [class^="GridItemStyle"] {
            padding-bottom: 15px;
        }
        .react-datetime-picker:focus-within {
            border-width: 1px !important;
            padding: 7px !important;
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        label {
                            font-size: 15px !important;
                        }
                        [class^="GridOffset"] {
                            display: flex;
                            flex-wrap: wrap;
                            width: 100%;
                            margin: 0;
                        }
                    `,
                    null,
                    css`
                        [class^="GridItemStyle"] {
                            padding: 10px 5px;
                        }
                        label {
                            font-size: 12px;
                        }

                        @supports (-webkit-touch-callout: none) {
                            .react-datetime-picker {
                                padding: 3px 2px 5px;
                            }

                            .react-datetime-picker__button {
                                right: 6px;
                                top: 17px;
                            }
                        }

                        .react-datetime-picker__button {
                            span {
                                width: 34px;
                            }
                        }

                        [class^="GridOffset"] {
                            display: flex;
                            flex-wrap: wrap;
                            width: 100%;
                            margin: 0;
                        }
                    `,
                    null,
                ],
                "max",
            )}
    `,
};

filterStyles.shipToGridItem = { width: [12, 12, 4, 4, 4] };
filterStyles.orderNumberGridItem = {
    width: [12, 12, 2, 2, 2],
    css: css`
        padding-left: 0;
        padding-right: 0;
    `,
};

filterStyles.datesGridItem = {
    width: [12, 12, 6, 6, 4],
    css: css`
        align-items: center;
        [class^="GridItemStyle"] {
            padding: 0 5px !important;
        }
        .react-datetime-picker__button {
            border: 0px;
            background: transparent;
            padding: 0px;
            position: absolute;
            right: 9px;
            top: 50%;
            transform: translateY(-50%);
            span {
                background: transparent;
            }
        }

        .react-datetime-picker__inputGroup {
            input {
                padding: 0 2px;
            }
        }

        .react-datetime-picker__inputGroup__leadingZero {
            padding: 0 0 0 2px;
            + input {
                padding: 0 2px 0 0;
            }
        }

        .react-datetime-picker {
            padding: 7px;
        }
        label {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            font-size: 12px;
                        `,
                        css`
                            font-size: 15px;
                        `,
                        null,
                    ],
                    "min",
                )}
        }
    `,
};

headerStyles.headerGridContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        [class^="GridOffset"] {
                            width: 100%;
                            margin: 0;
                        }

                        ~ [class^="GridWrapper"] {
                            [class^="GridOffset"] {
                                width: 100%;
                                margin: 0;
                            }

                            [class^="GridItemStyle"] {
                                padding: 0;

                                [class^="GridItemStyle"] {
                                    padding: 15px 5px 15px 5px;
                                }
                            }
                        }
                    `,
                    css`
                        [class^="GridOffset"] {
                            width: 100%;
                            margin: 0;
                        }

                        ~ [class^="GridWrapper"] {
                            [class^="GridOffset"] {
                                width: 100%;
                                margin: 0;
                            }

                            [class^="GridItemStyle"] {
                                padding: 0;

                                [class^="GridItemStyle"] {
                                    padding: 15px 5px;
                                }
                            }
                        }
                    `,
                    null,
                ],
                "max",
            )}
    `,
};

headerStyles.titleGridItem = {
    width: [10, 10, 10, 6, 6],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding-left: 0;
                    `,
                    null,
                ],
                "max",
            )}
    `,
};
searchFormStyles.headingText = {
    css: css`
        display: none;
    `,
};

orderLinesListStyles.titleGridItem = {
    css: css`
        display: none;
    `,
};

customerSelectorToolbarStyles.searchButton = {
    variant: "primary",
    css: css`
        margin-left: auto;
        width: 110px;
    `,
};

billingAddressStyles.titleText = {
    variant: "h5",
    as: "h2",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
};
shippingAddressStyles.titleText = {
    variant: "h5",
    as: "h2",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
};

clearButtonStyles.clearButton = {
    variant: "secondary",
    css: css`
        float: right;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    position: absolute;
                    right: 0;
                    bottom: 0;
                `,
                null,
            ])}
    `,
};
cardContainerStyles.cardDivider = {
    css: css`
        width: 100%;
        border-top: 1px solid ${getColor("common.border")};
        &:last-child {
            border-bottom: 1px solid ${getColor("common.border")};
        }
    `,
};
